// @flow
import React from 'react';
import doubleChevron from '../../../assets/images/double-chevron-left.svg';

import {
  Flex,
} from '../../../styled/index';
import {
  FooterContainer, DoubleArrow,
} from './styled/index';


type Props = {
  /**
   * Function that is called after click
   * */
  onClick?: { (): void },
};

/**
 * Sidebar footer component
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](https://github.com/rahmonzoda)
 */
const SidebarFooter = ({ onClick }: Props) => (
  <FooterContainer onClick={onClick}>
    <Flex align="center">
      <DoubleArrow src={doubleChevron} />
    </Flex>
  </FooterContainer>
);

SidebarFooter.defaultProps = {
  onClick: () => {},
};

export default SidebarFooter;
